import { CompleteSignUpResponse, ResendOtpRequest, SignupRequest, SignupResponse, VerifyOTPRequest } from "../model/customer/customer-v2";
import { apiSlice } from "../stores/base/api-slice";
import { resolveUtilityName } from "../tenant/branding/resolveTenant";
export const customerServiceEndpoints = apiSlice.injectEndpoints({ 
  endpoints: builder => ({ 
    startSignup: builder.mutation<SignupResponse, SignupRequest>({
      query: (credentials) => ({
        url: '/user/customer/registration/initiate',
        method: 'POST',
        body: { ...credentials, utilityName: resolveUtilityName() },
      }),
    }),
    verifyOTP: builder.mutation<void, VerifyOTPRequest>({
      query: (data) => ({
        url: '/user/customer/otp/validate',
        method: 'POST',
        body: { ...data, utilityName: resolveUtilityName() },
      }),
    }),
    resendRegistrationOtp: builder.mutation<void, ResendOtpRequest>({
      query: (data) => ({
        url: '/user/customer/otp/refresh',
        method: 'POST',
        body: { ...data, utilityName: resolveUtilityName() },
      }),
    }),
    completeRegistration: builder.mutation<CompleteSignUpResponse, { signupId: string}>({
      query: (data) => ({
        url: '/user/customer/registration/complete',
        method: 'POST',
        body: { ...data, utilityName: resolveUtilityName() },
      }),
    }),
     createPin: builder.mutation<void, {pin: string}>({
      query: (data) => ({
        url: '/user/customer/save-pin',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ["UserProfile"],
    }),
    verifyReferralCode: builder.query<boolean, string>({
      query: (referralCode) => ({
        url: '/user/staff-referrals/verify',
        params: { ReferralCode: referralCode, utilityName: resolveUtilityName() },
      }),
    }),
  })
});

export const { useStartSignupMutation,
    useVerifyOTPMutation,
    useResendRegistrationOtpMutation,
    useCompleteRegistrationMutation,
    useCreatePinMutation,
    useLazyVerifyReferralCodeQuery,
} = customerServiceEndpoints